import { useLocation } from "@reach/router";
import React, { useEffect } from "react";
import useEventDetails from "../../hooks/useEventDetails";
import { registerV2Alpha } from '../../services/auth';
import { useRegistrationStore } from "../../store/registrationStore";
import { useModalStore } from "../../store/useModalStore";
import useSessionStore from "../../store/useSessionsStore";
import { StepDataMap } from '../RegistrationStepper/steps';
import EmailLink from "../links/EmailLink";
import LoginSection from "../section/login";
import RegistrationSection from "../section/registration";
import { LoginModalWrapper } from "../styled";
import Modal from "./modal";
// import RegistrationStepper from '../RegistrationStepper';

const LoginModal = () => {
  const { resetState } = useRegistrationStore();
  const { virtual } = useEventDetails();
  const location = useLocation();
  const { selectedSessions, resetSessions } = useSessionStore();
  const { opened, isClosable, closeModal, openModal, setModalType} = useModalStore();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('registration') === 'true') {
      openModal();
    }
  }, [location.search, openModal]);

  const handleOnClose = () => {
    if (isClosable) {
      closeModal();
    }
  };

  // This will be used if the form is submitted without payment via stripe.
  const handleRegistration = async (userData: StepDataMap) => {
    const { attendeeDetailsStep } = userData;

    const { firstName, lastName, email } = attendeeDetailsStep;

    const payload = {
      email: email,
      given_name: firstName,
      family_name: lastName,
      agenda: selectedSessions,
    };

    try {
      await registerV2Alpha(payload, {});
    } catch (error) {
      console.error('Registration error:', error);
    }
  };
  
  const handleOnComplete = async (userData: StepDataMap) => {
    await handleRegistration(userData);
    resetState();
    resetSessions();
    setModalType('confirm');
    openModal();
  };

  return (
    <Modal open={opened} onClose={handleOnClose}>
      <LoginModalWrapper>
        <div className={virtual ? "brandingReg virtual" : "brandingReg"}></div>
        <section>
          <LoginSection />
          {/* <RegistrationStepper onComplete={handleOnComplete} /> */}
          <RegistrationSection />
          <EmailLink
            title="Get assistance"
            label="Help! Need Assistance?"
            email="events@scoopnewsgroup.com"
            subject="Zero Trust Summit - Login/Registration Help"
            className="assistance footer"
          />
        </section>
      </LoginModalWrapper>
    </Modal>
  );
};

export default LoginModal;
